const LOGO_URL = "https://customer-assets.emergentagent.com/job_6e85a7b3-7844-4782-8600-31defd3a9a43/artifacts/5fhyey8q_MV%20trasporti%20logo.png";

function buildLabelHtml(shipment, colloIndex, totalColli, collo) {
  const s = shipment;
  const origin = s.origin_details || { name: "", company: "", address: "", city: s.origin, cap: "", province: "", phone: "" };
  const dest = s.dest_details || { name: "", company: "", address: "", city: s.destination, cap: "", province: "", phone: "" };
  const svcLabel = { trasporto: "TRASPORTO", logistica: "LOGISTICA", magazzino: "MAGAZZINO" }[s.service_type] || s.service_type?.toUpperCase() || "";
  const urgLabel = { normale: "", urgente: "URGENTE", programmata: "PROGRAMMATA" }[s.urgency] || "";
  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=260x260&ecl=H&qzone=4&data=${encodeURIComponent(s.tracking_number + "-" + (colloIndex + 1))}`;
  const date = new Date(s.created_at).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" });
  const tipoLabel = collo ? (collo.tipo === "pallet" ? "PLT" : "CLO") : "";

  return `<div class="label">
    <!-- Top bar -->
    <div class="top-bar">
      <img src="${LOGO_URL}" alt="MV" class="logo" />
      <div class="tracking-box">
        <span class="tracking-label">TRACKING</span>
        <span class="tracking-num">${s.tracking_number}</span>
      </div>
    </div>

    <!-- Collo indicator -->
    <div class="collo-bar">
      <span class="collo-num">${tipoLabel || "CLO"} ${colloIndex + 1} / ${totalColli}</span>
      ${collo && collo.peso ? `<span class="collo-info">${collo.peso} kg</span>` : ""}
      ${collo && collo.dimensioni ? `<span class="collo-info">${collo.dimensioni}</span>` : ""}
      ${urgLabel ? `<span class="collo-urgent">${urgLabel}</span>` : ""}
    </div>

    <!-- Addresses -->
    <div class="addr-wrap">
      <div class="from-panel">
        <div class="addr-tag">DA / MITTENTE</div>
        <div class="addr-name">${origin.name}</div>
        ${origin.company ? `<div class="addr-detail">${origin.company}</div>` : ""}
        <div class="addr-detail">${origin.address}</div>
        <div class="addr-detail"><strong>${origin.cap} ${origin.city}</strong> ${origin.province ? `(${origin.province})` : ""}</div>
        ${origin.phone ? `<div class="addr-detail">Tel: ${origin.phone}</div>` : ""}
      </div>
      <div class="to-panel">
        <div class="to-priority-stripe"><span class="to-priority-text">DESTINAZIONE PRIORITARIA</span></div>
        <div class="addr-tag to-tag">A / DESTINATARIO</div>
        <div class="addr-name to-name">${dest.name}</div>
        ${dest.company ? `<div class="company-line">${dest.company}</div>` : ""}
        <div class="street-line">${dest.address}</div>
        <div class="city-line">${dest.cap} ${dest.city} ${dest.province ? `(${dest.province})` : ""}</div>
        ${dest.phone ? `<div class="addr-detail to-phone">Tel: ${dest.phone}</div>` : ""}
        ${s.note ? `<div class="note-line">NOTE: ${String(s.note).replace(/</g, "&lt;")}</div>` : ""}
      </div>
    </div>

    <!-- Bottom -->
    <div class="bottom-row">
      <div class="info-grid">
        <div class="info-cell"><span class="info-label">SERVIZIO</span><span class="info-value">${svcLabel}</span></div>
        <div class="info-cell"><span class="info-label">DATA</span><span class="info-value">${date}</span></div>
      </div>
      <div class="qr-area">
        <img src="${qrUrl}" class="qr" alt="QR" />
      </div>
    </div>
  </div>`;
}

function getLabelsForShipment(shipment) {
  const colli = shipment.colli && shipment.colli.length > 0 ? shipment.colli : null;
  if (colli) {
    const totalColli = colli.reduce((sum, c) => sum + (parseInt(c.quantita) || 1), 0);
    const labels = [];
    let globalIdx = 0;
    for (const c of colli) {
      const qty = parseInt(c.quantita) || 1;
      for (let q = 0; q < qty; q++) {
        labels.push(buildLabelHtml(shipment, globalIdx, totalColli, c));
        globalIdx++;
      }
    }
    return labels;
  }
  // Legacy: single label for old shipments without colli array
  const legacyCollo = { tipo: shipment.tipo_imballo || "collo", peso: shipment.weight || "", dimensioni: shipment.dimensions || "" };
  return [buildLabelHtml(shipment, 0, 1, legacyCollo)];
}

const LABEL_STYLES = `
  * { margin: 0; padding: 0; box-sizing: border-box; }
  body { font-family: 'Helvetica Neue', Arial, sans-serif; background: white; }
  .label { width: 96mm; height: 136mm; border: 1.5pt solid #222; display: flex; flex-direction: column; overflow: hidden; }

  .top-bar { display: flex; align-items: center; justify-content: space-between; padding: 2.5mm 3mm; border-bottom: 1.5pt solid #222; background: #fafafa; }
  .logo { height: 9mm; width: auto; }
  .tracking-box { text-align: right; }
  .tracking-label { display: block; font-size: 5.5pt; font-weight: 700; letter-spacing: 2px; color: #999; }
  .tracking-num { display: block; font-size: 12pt; font-weight: 900; letter-spacing: 1px; color: #111; }

  .collo-bar { display: flex; align-items: center; gap: 3mm; padding: 2mm 3mm; background: #111; color: white; }
  .collo-num { font-size: 10pt; font-weight: 900; letter-spacing: 1px; }
  .collo-info { font-size: 7pt; font-weight: 600; color: #ccc; }
  .collo-urgent { font-size: 6pt; font-weight: 800; background: #e53e3e; color: white; padding: 1px 4px; letter-spacing: 1px; margin-left: auto; }

  .addr-wrap { flex: 1; display: flex; flex-direction: column; gap: 2mm; padding: 2.2mm 2.6mm; background: linear-gradient(180deg, #fff 0%, #fcfcfc 100%); }
  .from-panel { border: 1pt solid #d9d9d9; padding: 2mm 2.4mm; background: #fcfcfc; min-height: 25mm; }
  .to-panel { flex: 1; border: 1.5pt solid #111; background: linear-gradient(180deg, #fff5ee 0%, #fff 100%); padding: 2.4mm 8.2mm 2.6mm 2.6mm; display: flex; flex-direction: column; justify-content: flex-start; position: relative; overflow: visible; }
  .to-priority-stripe { position: absolute; right: 1.2mm; top: 3.1mm; bottom: 3.1mm; width: 4.8mm; background: #333333; display: flex; align-items: center; justify-content: center; overflow: hidden; }
  .to-priority-text { display: inline-block; transform: rotate(-90deg); transform-origin: center center; white-space: nowrap; color: #fff; font-size: 5.2pt; font-weight: 900; letter-spacing: 0.08em; line-height: 1; }
  .addr-tag { font-size: 5.1pt; font-weight: 800; letter-spacing: 1.5px; color: #888; margin-bottom: 1.6mm; text-transform: uppercase; }
  .addr-tag.to-tag { color: #333333; }
  .addr-name { font-size: 8.1pt; font-weight: 800; color: #111; line-height: 1.18; margin-bottom: 0.7mm; }
  .addr-name.to-name { font-size: 12pt; line-height: 1.05; text-transform: uppercase; letter-spacing: -0.02em; margin-right: 7mm; }
  .addr-detail { font-size: 6.9pt; color: #444; line-height: 1.42; }
  .addr-detail strong { color: #111; }
  .company-line { font-size: 8.5pt; font-weight: 900; color: #101010; text-transform: uppercase; margin: 0.9mm 0; max-width: 49mm; }
  .street-line { font-size: 8.3pt; font-weight: 700; color: #111; margin-top: 1.2mm; }
  .city-line { margin-top: 0.9mm; font-size: 8.8pt; font-weight: 900; line-height: 1.25; color: #111; }
  .to-phone { margin-top: 0.9mm; }
  .note-line { margin-top: 1.2mm; font-size: 6.2pt; font-weight: 700; color: #92400E; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

  .bottom-row { display: flex; align-items: stretch; border-top: 1.5pt solid #222; }
  .info-grid { flex: 1; display: flex; flex-wrap: wrap; }
  .info-cell { flex: 1 1 auto; min-width: 25mm; padding: 1.5mm 3mm; border-right: 0.5pt solid #e0e0e0; }
  .info-cell:last-child { border-right: none; }
  .info-label { display: block; font-size: 4.5pt; font-weight: 700; letter-spacing: 1.5px; color: #999; }
  .info-value { display: block; font-size: 7pt; font-weight: 700; color: #222; margin-top: 0.3mm; }
  .qr-area { width: 35mm; min-width: 35mm; display: flex; align-items: center; justify-content: center; border-left: 1.5pt solid #222; padding: 1mm; background: #fafafa; }
  .qr { width: 31mm; height: 31mm; }

  @media print {
    body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  }
`;

/* Single shipment: prints one label per collo
   options.kind: 'shipment' | 'pickup' (used only if useServer=true)
   options.useServer: if true, uses backend ReportLab endpoint (admin-only) */
export function printShipmentLabel(shipment, options = {}) {
  const labels = getLabelsForShipment(shipment);
  const kind = options.kind === "pickup" ? "pickups" : "shipments";
  const serverPdf = options.useServer && shipment && shipment.id ? {
    baseUrl: `/api/admin/${kind}/${shipment.id}/label.pdf`,
    filename: `etichette_${shipment.tracking_number}.pdf`,
  } : null;
  openPrintWindow(labels, `Etichette ${shipment.tracking_number}`, serverPdf, null);
}

/* Multiple shipments: 4 labels per A4, one label per collo
   options.useServer: if true, admin bulk endpoint POST /api/admin/labels/bulk.pdf */
export function printMultipleLabels(shipments, options = {}) {
  if (!shipments || shipments.length === 0) return;
  const allLabels = shipments.flatMap((s) => getLabelsForShipment(s));
  const bulkItems = options.useServer
    ? shipments.map((s) => ({ kind: s._type === "ritiro" ? "pickup" : "shipment", id: s.id })).filter((it) => it.id)
    : null;
  const serverBulk = bulkItems && bulkItems.length ? {
    url: `/api/admin/labels/bulk.pdf`,
    filename: `etichette_bulk.pdf`,
    items: bulkItems,
  } : null;
  openPrintWindow(allLabels, `Etichette MV Trasporti (${allLabels.length})`, null, serverBulk);
}

function openPrintWindow(labels, title, serverPdf, serverBulk) {
  const wrappedLabels = labels.map((l) => `<div class="label-cell">${l}</div>`).join("\n");
  const safeTitle = title.replace(/[^a-zA-Z0-9-_]/g, "_");

  // Auth token + backend base for server-side PDF endpoint (single-shipment only).
  // Passed into the popup HTML: same origin, no cross-window messaging needed.
  const token = localStorage.getItem("mv_admin_token") || localStorage.getItem("mv_client_token") || "";
  const backendBase = process.env.REACT_APP_BACKEND_URL || "";
  const serverPdfBaseUrl = serverPdf ? `${backendBase}${serverPdf.baseUrl}` : "";
  const serverPdfFilename = serverPdf ? serverPdf.filename : "";
  const bulkUrl = serverBulk ? `${backendBase}${serverBulk.url}` : "";
  const bulkFilename = serverBulk ? serverBulk.filename : "";
  const bulkItemsJson = serverBulk ? JSON.stringify(serverBulk.items) : "null";

  const html = `<!DOCTYPE html>
<html lang="it">
<head>
  <meta charset="UTF-8">
  <title>${title}</title>
  <script src="https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js"></script>
  <style>
    ${LABEL_STYLES}
    @page { size: A4; margin: 0; }
    body { margin: 0; }
    .toolbar { position: sticky; top: 0; z-index: 100; background: #09090B; color: white; padding: 10px 16px; display: flex; gap: 12px; align-items: center; flex-wrap: wrap; box-shadow: 0 2px 8px rgba(0,0,0,0.15); }
    .toolbar h1 { font-size: 14px; font-weight: 700; letter-spacing: 1px; text-transform: uppercase; margin: 0; flex: 1; min-width: 200px; }
    .toolbar button { font-family: 'Helvetica Neue', Arial, sans-serif; font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; padding: 8px 18px; border: none; cursor: pointer; border-radius: 2px; transition: opacity 0.15s; }
    .toolbar button:hover { opacity: 0.85; }
    .toolbar button:disabled { opacity: 0.5; cursor: not-allowed; }
    .btn-print { background: #FF5200; color: white; }
    .btn-pdf { background: white; color: #09090B; }
    .toolbar-info { font-size: 11px; color: #999; }
    .pos-wrap { display: flex; align-items: center; gap: 10px; padding: 0 10px; border-left: 1px solid #333; border-right: 1px solid #333; }
    .pos-wrap .pos-label { font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 1.5px; color: #ccc; }
    .pos-grid { display: grid; grid-template-columns: repeat(2, 24px); grid-template-rows: repeat(2, 24px); gap: 3px; }
    .pos-grid button.pos-cell { padding: 0; width: 24px; height: 24px; background: #333; color: #ccc; border: 1px solid #555; border-radius: 2px; font-size: 11px; font-weight: 700; cursor: pointer; letter-spacing: 0; text-transform: none; }
    .pos-grid button.pos-cell.active { background: #FF5200; color: white; border-color: #FF5200; }
    .pos-grid button.pos-cell:hover:not(.active) { background: #444; }
    .grid { display: flex; flex-wrap: wrap; width: 210mm; justify-content: flex-start; align-content: flex-start; margin: 12px auto; }
    .label-cell { width: 105mm; height: 148.5mm; display: flex; align-items: center; justify-content: center; }
    .label-cell.empty { background: repeating-linear-gradient(45deg, #f7f7f7, #f7f7f7 6px, #efefef 6px, #efefef 12px); }
    @media print {
      .toolbar { display: none !important; }
      .grid { margin: 0; }
    }
  </style>
</head>
<body>
  <div class="toolbar" id="mv-toolbar">
    <h1>${title}</h1>
    <span class="toolbar-info">${labels.length} etichett${labels.length === 1 ? "a" : "e"}</span>
    <div class="pos-wrap" data-testid="label-position-picker">
      <span class="pos-label">Posizione</span>
      <div class="pos-grid">
        <button type="button" class="pos-cell" data-pos="1" data-testid="label-pos-1">1</button>
        <button type="button" class="pos-cell" data-pos="2" data-testid="label-pos-2">2</button>
        <button type="button" class="pos-cell" data-pos="3" data-testid="label-pos-3">3</button>
        <button type="button" class="pos-cell" data-pos="4" data-testid="label-pos-4">4</button>
      </div>
    </div>
    <button class="btn-pdf" id="btn-pdf" type="button" data-testid="label-download-pdf-btn">Scarica PDF</button>
    <button class="btn-print" id="btn-print" type="button" data-testid="label-print-btn">Stampa</button>
  </div>
  <div id="mv-content">
    <div class="grid" id="mv-grid">
    ${wrappedLabels}
    </div>
  </div>
  <script>
    var SERVER_PDF_BASE_URL = ${JSON.stringify(serverPdfBaseUrl)};
    var SERVER_PDF_FILENAME = ${JSON.stringify(serverPdfFilename)};
    var BULK_URL = ${JSON.stringify(bulkUrl)};
    var BULK_FILENAME = ${JSON.stringify(bulkFilename)};
    var BULK_ITEMS = ${bulkItemsJson};
    var AUTH_TOKEN = ${JSON.stringify(token)};
    var SAFE_TITLE = ${JSON.stringify(safeTitle)};

    // Restore last chosen position from parent localStorage (default = 1)
    var initialPos = 1;
    try {
      initialPos = parseInt((window.opener && window.opener.localStorage.getItem('mv_label_position')) || '1', 10) || 1;
      if (initialPos < 1 || initialPos > 4) initialPos = 1;
    } catch(e){}

    var posButtons = document.querySelectorAll('.pos-cell');
    function setActivePos(p) {
      posButtons.forEach(function(b){ b.classList.toggle('active', parseInt(b.getAttribute('data-pos'),10) === p); });
    }
    setActivePos(initialPos);

    function saveChoice(pos) {
      try {
        if (window.opener) {
          window.opener.localStorage.setItem('mv_label_position', String(pos));
        }
      } catch(e){}
    }

    function currentPos() {
      var active = document.querySelector('.pos-cell.active');
      return active ? parseInt(active.getAttribute('data-pos'),10) : 1;
    }

    // Preview: prepend (pos-1) empty spacer cells so browser Print also respects the position.
    var LABEL_HTMLS = ${JSON.stringify(labels)};
    function renderPreview() {
      var grid = document.getElementById('mv-grid');
      var pos = currentPos();
      var skip = Math.max(0, Math.min(3, pos - 1));
      var cells = [];
      for (var i = 0; i < skip; i++) cells.push('<div class="label-cell empty"></div>');
      for (var j = 0; j < LABEL_HTMLS.length; j++) {
        cells.push('<div class="label-cell">' + LABEL_HTMLS[j] + '</div>');
      }
      grid.innerHTML = cells.join('\\n');
      saveChoice(pos);
    }

    posButtons.forEach(function(b){
      b.addEventListener('click', function(){
        setActivePos(parseInt(b.getAttribute('data-pos'),10));
        renderPreview();
      });
    });
    renderPreview();

    document.getElementById('btn-print').addEventListener('click', function(){ window.print(); });

    function downloadBlob(blob, filename) {
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url; a.download = filename; document.body.appendChild(a);
      a.click(); a.remove();
      setTimeout(function(){ URL.revokeObjectURL(url); }, 3000);
    }

    function fallbackClientPdf(btn) {
      btn.textContent = 'Generazione PDF...';
      var content = document.getElementById('mv-content');
      var opt = {
        margin: 0,
        filename: SAFE_TITLE + '.pdf',
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true, allowTaint: false, backgroundColor: '#ffffff' },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        pagebreak: { mode: ['css', 'legacy'], avoid: '.label-cell' }
      };
      return window.html2pdf().set(opt).from(content).save().then(function(){
        btn.disabled = false; btn.textContent = 'Scarica PDF';
      }).catch(function(){
        btn.disabled = false; btn.textContent = 'Scarica PDF';
        alert('Errore generazione PDF. Riprova o usa il bottone Stampa > Salva come PDF.');
      });
    }

    document.getElementById('btn-pdf').addEventListener('click', function(){
      var btn = this;
      btn.disabled = true;
      var pos = currentPos();

      // Single-shipment path: GET label.pdf?layout=a4&position=N
      if (SERVER_PDF_BASE_URL && AUTH_TOKEN) {
        btn.textContent = 'Generazione PDF...';
        var url = SERVER_PDF_BASE_URL + '?layout=a4&position=' + pos;
        fetch(url, { headers: { 'Authorization': 'Bearer ' + AUTH_TOKEN } })
          .then(function(r){
            if (!r.ok) throw new Error('HTTP ' + r.status);
            return r.blob();
          })
          .then(function(blob){
            downloadBlob(blob, SERVER_PDF_FILENAME || (SAFE_TITLE + '.pdf'));
            btn.disabled = false; btn.textContent = 'Scarica PDF';
          })
          .catch(function(err){
            console.warn('Backend PDF failed, falling back to client-side:', err);
            fallbackClientPdf(btn);
          });
        return;
      }
      // Bulk path: POST /api/admin/labels/bulk.pdf
      if (BULK_URL && AUTH_TOKEN && BULK_ITEMS && BULK_ITEMS.length) {
        btn.textContent = 'Generazione PDF...';
        fetch(BULK_URL, {
          method: 'POST',
          headers: { 'Authorization': 'Bearer ' + AUTH_TOKEN, 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: BULK_ITEMS, layout: 'a4', position: pos })
        }).then(function(r){
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.blob();
        }).then(function(blob){
          downloadBlob(blob, BULK_FILENAME || (SAFE_TITLE + '.pdf'));
          btn.disabled = false; btn.textContent = 'Scarica PDF';
        }).catch(function(err){
          console.warn('Bulk backend PDF failed, falling back to client-side:', err);
          fallbackClientPdf(btn);
        });
        return;
      }
      // No server endpoint available → client-side
      fallbackClientPdf(btn);
    });
  </script>
</body>
</html>`;

  const win = window.open("", "_blank", "width=900,height=1000");
  if (win) { win.document.write(html); win.document.close(); }
}
